import z from 'zod';

export const FanforgeUserJwtClaimsBaseSchema = z.object({
  iss: z.string(), // issuer
  aud: z.string(), // audience
  sub: z.string(), // subject
  iat: z.number().optional(), // issued at
  exp: z.number().optional(), // expires at
  admin: z.boolean(), // is admin
});

export type FanforgeUserJwtClaimsBase = z.infer<typeof FanforgeUserJwtClaimsBaseSchema>;
